import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch lifecycle types
 * @returns {Object} Lifecycle types, loading state, and error
 */
export const useCropLifecycleTypes = () => {
  const [cropLifecycleTypes, setCropLifecycleTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data: cropLifecycleTypesData, error: cropLifecycleTypesError } =
          await supabaseGetter.cropLifecycleTypes.getAll();

        if (cropLifecycleTypesError) throw cropLifecycleTypesError;

        setCropLifecycleTypes(cropLifecycleTypesData || null);
      } catch (err) {
        console.error('Error fetching lifecycle types data:', err);
        setError(err.message);
        setCropLifecycleTypes([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return {
    cropLifecycleTypes,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropLifecycleTypes.invalidate();
    }
  };
}
